import { useCurrentOrganization } from '@/shared/hooks/organization';
import useAllUserWorkspaces from '@/shared/hooks/workspace/useAllUserWorkspaces';
import { useMemo } from 'react';

export default function useWorkspacesMemberInOrganization() {
  const organization = useCurrentOrganization();
  const { data: allWorkspaces, isLoading, isFetching } = useAllUserWorkspaces();

  const filteredWorkspaces = useMemo(() => {
    return (
      allWorkspaces?.filter(
        workspace => workspace?.organizationId === organization?.id
      ) || []
    );
  }, [allWorkspaces, organization?.id]);

  return { data: filteredWorkspaces, isLoading, isFetching };
}
